export const INVOICE_TAGS_INFO = {
  NEGOTIATED: {
    color: 'negotiated',
    text: 'Negociada',
  },
  PAID: {
    color: 'paid',
    text: 'Pago',
  },
  OPEN: {
    color: 'open',
    text: 'Aberta',
  },
  SCHEDULED: {
    color: 'scheduled',
    text: 'Agendada',
  },
  ISSUED: {
    color: 'issued',
    text: 'Emitida',
  },
  EXPIRED: {
    color: 'expired',
    text: 'Vencida',
  },
}

export const SERVICES_CARDS_TAGS = {
  NEW: {
    STYLE: 'new',
    TEXT: 'Novo',
  },
}
